
import React, { useState } from 'react';
import GmailCopy from './GmailCopy';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('http://localhost:5000/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ 
          type: 'success', 
          message: 'Message sent successfully! I will get back to you soon.' 
        });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({ 
          type: 'error', 
          message: data.message || 'Failed to send message. Please try again.' 
        });
      }
    } catch (error) {
      setStatus({ 
        type: 'error', 
        message: 'Network error. Please check if the server is running.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id='contact' className='flex flex-col px-4 sm:px-6 md:px-8 lg:px-16 py-8 sm:py-12 md:py-16 mt-6 sm:mt-10 gap-8 sm:gap-10 md:gap-12'>
      <div className='flex flex-col max-w-3xl mx-auto w-full'>
        <h1 className='tracking-wide sm:tracking-wider font-semibold text-xl sm:text-2xl md:text-3xl lg:text-3xl mb-2'>
          Contact Me
        </h1>
        <p className='text-sm sm:text-base text-gray-600 dark:text-gray-400'>You can contact me at<GmailCopy/></p>
      </div>
      
      <div className='flex justify-center w-full'>
        <form className='flex flex-col gap-4 sm:gap-5 w-full max-w-3xl' onSubmit={sendEmail}>
          
          {/* Status Message */}
          {status.message && (
            <div className={`p-4 rounded-lg text-sm sm:text-base ${
              status.type === 'success' 
                ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-300 dark:border-green-700' 
                : 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 border border-red-300 dark:border-red-700'
            }`}>
              {status.message}
            </div>
          )}
          
          <div className='flex flex-col gap-2'>
            <label className='text-sm sm:text-base font-medium'>Name</label>
            <input 
              className='p-3 sm:p-4 rounded-lg bg-gray-100 dark:bg-[#3d3e4b] border border-gray-300 dark:border-gray-600 focus:border-[#ec6e59] dark:focus:border-[#ec6e59] focus:outline-none transition-colors text-sm sm:text-base'
              placeholder='Your name'
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>

          <div className='flex flex-col gap-2'>
            <label className='text-sm sm:text-base font-medium'>Email</label>
            <input 
              className='p-3 sm:p-4 rounded-lg bg-gray-100 dark:bg-[#3d3e4b] border border-gray-300 dark:border-gray-600 focus:border-[#ec6e59] dark:focus:border-[#ec6e59] focus:outline-none transition-colors text-sm sm:text-base'
              placeholder='your.email@example.com'
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>

          <div className='flex flex-col gap-2'>
            <label className='text-sm sm:text-base font-medium'>Your Message</label>
            <textarea
              className='p-3 sm:p-4 resize-none rounded-lg bg-gray-100 dark:bg-[#3d3e4b] border border-gray-300 dark:border-gray-600 focus:border-[#ec6e59] dark:focus:border-[#ec6e59] focus:outline-none transition-colors h-40 sm:h-48 text-sm sm:text-base'
              placeholder='Write your message here...'
              name="message"
              value={formData.message}
              onChange={handleChange}
              required 
            />
          </div>

          <div className='flex justify-start mt-2 sm:mt-4'>
            <button 
              type='submit'
              disabled={isSubmitting}
              className='px-8 sm:px-10 py-3 sm:py-3.5 bg-[#ec6e59] hover:bg-[#d95d4a] disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl text-sm sm:text-base flex items-center gap-2'
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Sending...
                </>
              ) : (
                'Send Message'
              )}
            </button>
          </div>
        </form>
      </div>

      <div className='flex justify-center items-center text-xs sm:text-sm text-gray-600 dark:text-gray-400 pt-8 sm:pt-10 border-t border-gray-200 dark:border-gray-700'>
        Copyright © 2026
        <span className='font-medium text-[#ec6e59] mx-1'>Alaeddine Rami</span>
        All Rights Reserved
      </div>

    </div>
  );
}

export default Contact;